import { IN_CA, IN_UK, IN_AU } from '../../utils/constants'

// Upsell Products without Plus
export const USA_CALENDAR_FIFTEEN = 'gid://shopify/ProductVariant/40416983416884'
export const CA_CALENDAR_FIFTEEN = 'gid://shopify/ProductVariant/43625206907074'
export const USA_BLACK_FRAME = 'gid://shopify/ProductVariant/41022774575156'

export const CAL_PLUS_FEATURES = {
  customizedScreensaver: {
    heading: 'Photo Screensaver',
    text: `Turn your Calendar into a photo frame when it's not in use! Upload photos with our app.`,
  },
  mealPlanning: {
    heading: 'Meal Planning',
    text: `Never answer, “What are we eating?” again! Plan the week's meals in just 5 minutes.`,
  },
  magicImport: {
    heading: 'Magic Import',
    text: `Forward any email or PDF from school and we’ll convert it into events on your calendar.`,
  },
}
export const PRODUCT_DROPDOWN_LABELS = {
  27: {
    label: `27" Calendar Max`,
  },
  15: {
    label: `15" Calendar`,
  },
  ...(IN_CA || IN_UK || IN_AU
    ? {}
    : {
        10: {
          label: `10" Calendar`,
        },
      }),
}

export const SPLIT_PRICE = {
  27: {
    Classic: '149.99',
    default: '157.49',
  },
  10: {
    default: '42.49',
  },
  15: {
    default: '74.99',
  },
}

// export const CAL_SIZE_PRICING = {
//   10: {
//     bubble: '$40 OFF',
//     regularPrice: '169.99',
//     discountedPrice: '129.99',
//   },
//   15: {
//     bubble: '$40 OFF',
//     regularPrice: '299.99',
//     discountedPrice: '259.99',
//   },
//   27: {
//     bubble: '',
//     regularPrice: '599.99',
//     discountedPrice: '',
//   },
// }

// Temp for CA BTS
const DEFAULT_CAL_SIZE_PRICING = {
  10: {
    bubble: '$40 OFF',
    regularPrice: '169.99',
    discountedPrice: '129.99',
  },
  15: {
    bubble: '$70 OFF',
    regularPrice: '449.00',
    discountedPrice: '379.00',
  },
  27: {
    bubble: '',
    regularPrice: '599.99',
    discountedPrice: '',
  },
}

const UK_CAL_SIZE_PRICING = {
  10: {
    bubble: '',
    regularPrice: '',
    discountedPrice: '',
  },
  15: {
    bubble: '15% OFF',
    regularPrice: '290.00',
    discountedPrice: '233.75',
  },
  27: {
    bubble: '',
    regularPrice: '599.99',
    discountedPrice: '',
  },
}

export const CAL_SIZE_PRICING = IN_UK ? UK_CAL_SIZE_PRICING : DEFAULT_CAL_SIZE_PRICING
